module.exports = __webpack_public_path__ + "img/GT.ShallowFoundation.StripFoundation.InSituConcreteTraditionalStrip850mm.ac7d99a4.png";